import theme from '@styles/theme';
import reusables from '@styles/theme/reusables';
export default {
  modalContainer: (active: boolean) => ({
    position: 'fixed',
    padding: ['89px 0', '89px 0', '89px 0', '89px 0', '90px 0'],
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    transform: `translateY(${active ? '0' : '100%'})`,
    ...reusables.mainTransition('transform', theme.transitions.animation.atomCurve, theme.transitions.time.normal),
    background: theme.rawColors.neutralWhite,
    zIndex: theme.zIndex.modalUp,
    height: '100vh',
    width: '100%',
    video: {
      objectFit: 'contain'
    }
  }),
  closeButton: {
    position: 'absolute',
    top: 16,
    right: 16
  }
};